'use client';

import { useEffect } from 'react';
import ModuleList, {
  Module,
} from '@/components/utilities/content-modules/module-list/module-list';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import styles from './booking-flow.module.scss';

export interface BookingFlowProps {
  /** An array of the content modules to show */
  contentModules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const BookingFlow = ({
  contentModules,
  personalizationData,
  trackingData,
}: BookingFlowProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'booking_flow' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.component}>
      <ModuleList modules={contentModules} />
    </div>
  );
};

BookingFlow.displayName = 'BookingFlow';

export default BookingFlow;
